<template>
  <Drawer :show="show" @close="emit('close')">
    <template #content>
      <div class="typography-body-1">{{ content }}</div>
    </template>
  </Drawer>
</template>

<script setup lang="ts">
defineProps<{
  show?: boolean
  content: string
}>()

const emit = defineEmits<{
  close: [value: void]
}>()
</script>
